// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SidePanel.css 
IMPORTANT: this is used to hide scrollbar on the SidePanel
*/
.sidePanel {
  height: calc(100vh - 66px);
  width: 25vw;
  min-width: 300px;
  max-width: 550px;
  background-color: transparent;
  border: none;
  position: absolute;
  top: 64px;
  left: 0;
  z-index: 1;
  overflow-y: auto;
  scrollbar-width: none; /* For Firefox */
}

.sidePanel::-webkit-scrollbar {
  display: none; /* For WebKit browsers */
}
`, "",{"version":3,"sources":["webpack://./src/components/side-panel/SidePanel.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,qBAAqB,EAAE,gBAAgB;AACzC;;AAEA;EACE,aAAa,EAAE,wBAAwB;AACzC","sourcesContent":["/* SidePanel.css \nIMPORTANT: this is used to hide scrollbar on the SidePanel\n*/\n.sidePanel {\n  height: calc(100vh - 66px);\n  width: 25vw;\n  min-width: 300px;\n  max-width: 550px;\n  background-color: transparent;\n  border: none;\n  position: absolute;\n  top: 64px;\n  left: 0;\n  z-index: 1;\n  overflow-y: auto;\n  scrollbar-width: none; /* For Firefox */\n}\n\n.sidePanel::-webkit-scrollbar {\n  display: none; /* For WebKit browsers */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
